interface DistribucionItem {
  seleccionado: boolean;
  montoAsignado: number;
}

/**
 * Distribuye un objetivo global entre los ítems seleccionados usando aritmética
 * de centavos para garantizar que la suma sea exactamente igual al objetivo.
 * Modo 'fija' + automat=true: distribución igual con sobrante al inicio.
 * Modo 'libre': items seleccionados quedan en 0 (edición manual).
 */
export function recalcularDistribucion<T extends DistribucionItem>(
  items: T[],
  modo: string,
  obj: number,
  automat: boolean
): T[] {
  const sel = items.filter(l => l.seleccionado).length;
  const objCents = Math.round(obj * 100);
  const baseAmountCents = sel > 0 ? Math.floor(objCents / sel) : 0;
  const remainderCents = sel > 0 ? objCents - baseAmountCents * sel : 0;
  let remainderAssigned = 0;
  return items.map(l => ({
    ...l,
    montoAsignado: (() => {
      if (l.seleccionado && modo === 'fija' && automat && sel > 0) {
        const extra = remainderAssigned < remainderCents ? 1 : 0;
        remainderAssigned++;
        return (baseAmountCents + extra) / 100;
      }
      if (l.seleccionado && modo === 'libre') return 0;
      return l.montoAsignado;
    })(),
  }));
}
